/* eslint-disable prettier/prettier */
import {
  DespatchAdvice,
  DespatchAdviceItem,
  Invoice,
  InvoiceItem,
  OrderResponse,
  OrderResponseItem,
  Visiblenote,
} from '../../data/models'

type MessageParams = Record<string, string>

export function getVisibleNotes(
  businessObject:
    | OrderResponse
    | OrderResponseItem
    | DespatchAdvice
    | DespatchAdviceItem
    | Invoice
    | InvoiceItem
    | undefined,
  filter: Visiblenote['IsVisibleOn'],
) {
  const notes = businessObject?.Meta?.VisibleNotes?.filter(
    note => note.IsVisibleOn === filter,
  )

  return notes
}

export function getVisibleNoteParams(note: Visiblenote) {
  return note.Parameters?.reduce((previous: MessageParams, current, index) => {
    previous[index] = current
    return previous
  }, {})
}
